import styled from 'styled-components';
import Icon from 'components/Icon';
import { Tag } from 'legacyComponents/styled/lib';

export const IconStyled = styled(Icon)`
  margin-left: ${props => props.theme.spacing.small};
  color: ${props => props.theme.color.wfOrange};
  transform-origin: center center;
  vertical-align: baseline;
  &:hover {
    transform: scale(1.3);
  }
`;

export const Wrapper = styled(Tag)`
  display: inline-block;
  padding: ${props => props.theme.spacing.xsmall}
    ${props => props.theme.spacing.small};
  margin-right: ${props => props.theme.spacing.small};
  margin-bottom: ${props => props.theme.spacing.small};
  > span:nth-of-type(2) {
    margin-right: ${props => props.theme.spacing.xsmall};
  }
`;
